import { Misc } from "@/data/util/Misc";

import { Ripple } from "@/shared/ui/Ripple";

import { TastierClient } from "@/app/TastierClient";
import { CovidDataCompletion } from "@/app/elements/CovidDataCompletion";
import { trans } from "@/app/localization/Trans";
import { BasePopover } from "@/app/popover/BasePopover";
import { Helper } from "@/app/ui/Helper";

export class CovidSignupPopover extends BasePopover {
    public onSigninClicked?: { () };
    public onSignUpClicked?: { () };
    private isTransitioning = false;

    private covidDataCompletion?: CovidDataCompletion;

    constructor() {
        super(trans.covidSignupPopover.title, false);

        this.updateTitle(undefined);

        this.$element.addClass("covidsignup");
        this.$body.addClass("scrollable");

        const isAuthenticated = TastierClient.identityContext.isAuthenticated();
        if (isAuthenticated) {
            this.showCovidForm(false);
        } else {
            this.showSwitch();
        }

        this.showAllContent();
    }

    public static isAlreadyOpen() {
        return $(".app > .popover.covidsignup").length !== 0;
    }

    protected onShow() {
        this.showAllContent();
    }

    protected onHide() {
        this.destroy();
    }

    protected onDestroy() {
        if (this.covidDataCompletion !== undefined) {
            this.covidDataCompletion.destroy();
            this.covidDataCompletion = undefined;
        }
    }

    private updateTitle(covidDataCompletionMode: string | undefined) {
        if (covidDataCompletionMode === undefined || covidDataCompletionMode === "tracing") {
            const serviceDesignation = Helper.getCurrentServiceDesignation();
            this.setTitle(serviceDesignation === undefined ? trans.covidSignupPopover.title : serviceDesignation);
        } else {
            this.setTitle('<i class="fas fa-qrcode"></i> ' + trans.covidSignupPopover.certificateTitle);
        }
    }

    private showCovidForm(canGoBack: boolean) {
        if (this.isTransitioning) return;

        if (this.covidDataCompletion !== undefined) this.covidDataCompletion.destroy();

        this.covidDataCompletion = new CovidDataCompletion().renderTo(this.$body);
        this.covidDataCompletion.onModeChanged = (mode) => {
            this.updateTitle(mode);
            this.setFullScreen(true);
        };

        this.covidDataCompletion.onDone = () => this.hide();
        this.covidDataCompletion.onCancel = async () => {
            if (canGoBack) {
                await this.hideAllContent();
                this.showSwitch();
                this.showAllContent();
                this.setFullScreen(false);
            } else this.hide();
        };

        this.covidDataCompletion.show();
    }

    private showSwitch() {
        if (this.isTransitioning) return;

        if (Misc.privateSurfing)
            $('<div class="hint">' + trans.covidSignupPopover.disablePrivate + "</div>").appendTo(this.$body);

        let btnGroup = $(
            '<div class="btngroup"><div class="hint">' + trans.covidSignupPopover.createAccount + "</div></div>"
        ).appendTo(this.$body);
        Ripple.bind(
            $('<button class="btn">' + trans.covidSignupPopover.signupBtn + "</button>")
                .appendTo(btnGroup)
                .click((e) => {
                    e.preventDefault();
                    if (this.onSignUpClicked !== undefined) this.onSignUpClicked();

                    this.hide();
                })
        );

        Ripple.bind(
            $('<button class="btn">' + trans.covidSignupPopover.signInBtn + "</button>")
                .appendTo(btnGroup)
                .click((e) => {
                    e.preventDefault();
                    if (this.onSigninClicked !== undefined) this.onSigninClicked();

                    this.hide();
                })
        );

        btnGroup = $(
            '<div class="btngroup last"><div class="hint">' + trans.covidSignupPopover.deleteAfterDays + "</div></div>"
        ).appendTo(this.$body);
        Ripple.bind(
            $('<button class="btn">' + trans.covidSignupPopover.onlyCoronaBtn + "</button>")
                .appendTo(btnGroup)
                .click(async (e) => {
                    e.preventDefault();
                    await this.hideAllContent();
                    this.showCovidForm(true);
                    this.showAllContent();
                })
        );
    }

    private hideAllContent(): Promise<void> {
        this.isTransitioning = true;

        return new Promise((s) => {
            const childs = this.$body.children();
            childs.removeClass("shown");

            setTimeout(() => {
                childs.remove();
                this.isTransitioning = false;
                s();
                return null;
            }, 250);
        });
    }

    private showAllContent() {
        this.$body.children().each((i, e) => {
            $(e)[0].offsetHeight;
            $(e).addClass("shown");
            this.$body.scrollTop(0);
        });
    }
}
